import { ChainId, Token } from '@pancakeswap/sdk'
import { useMemo } from 'react'
import { getAddress, isAddress } from 'viem'
import CurrencyLogo from 'components/Logo/CurrencyLogo'

/** Round token logo for any BEP-20 address (falls back to the generic mark when no logo is known). */
export default function TokenIcon({ address, symbol, decimals = 18, size = 48 }: { address?: string; symbol?: string; decimals?: number; size?: number }) {
  const token = useMemo(
    () => (address && isAddress(address) ? new Token(ChainId.BSC, getAddress(address), decimals, symbol ?? 'TOKEN') : undefined),
    [address, decimals, symbol],
  )
  return (
    <span style={{ display: 'inline-flex', width: size, height: size, flex: 'none', borderRadius: '50%', overflow: 'hidden' }}>
      {token ? <CurrencyLogo currency={token} size={`${size}px`} /> : null}
    </span>
  )
}
